import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import { usePage } from '@/hooks'
import React, { useEffect, useState } from 'react'
import { api } from '@/api'
import HaveQuestions from '@/components/HaveQuestions'
import DetailPageHead from '@/components/DetailPageHead/index.tsx'

const WhatToReadDetail = (): React.ReactElement => {
  const [element, setElement] = useState<any | undefined>()
  const page = usePage()
  const { object, global } = page.init_state
  const { config } = global

  useEffect(() => {
    api
      .getWhatReadDetail({ id: object.id })
      .then((data) => {
        setElement(data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [object.id])

  const audio = element?.property_audio_value ?? []
  return (
    <>
      <Container>
        <BackLink href={config.recommend_to_know} title='К рекомендую это знать' />

        <DetailPageHead
          image={element?.detail_picture}
          date={object.date_create}
          title={object.title}
          content={element?.detail_text}
        >
          {audio.map((item) => {
            return (
              <audio key={item} style={{ marginTop: '15px' }} controls src={item} controlsList='nodownload'>
                Your browser does not support the
                <code>audio</code> element.
              </audio>
            )
          })}
        </DetailPageHead>

      </Container>
      <HaveQuestions />
    </>
  )
}

export default WhatToReadDetail
